<div id="keyboard-controls-explanation">
    <img src="/images/keyboard-controls.png">
</div>